export default {
  dark: {
    navColor: "grey darken-3",
    secondaryNavColor: "transparent"
  }
};